import "./Counter.css";

import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

import {
  FaProjectDiagram,
  FaUsers,
  FaLaptopCode,
  FaAward,
} from "react-icons/fa";

function Counter() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const counterData = [
    {
      icon: <FaProjectDiagram />,
      number: 250,
      suffix: "+",
      title: "Projects Completed",
    },
    {
      icon: <FaUsers />,
      number: 180,
      suffix: "+",
      title: "Happy Clients",
    },
    {
      icon: <FaLaptopCode />,
      number: 12,
      suffix: "+",
      title: "Technologies",
    },
    {
      icon: <FaAward />,
      number: 5,
      suffix: "+",
      title: "Years Experience",
    },
  ];

  return (
    <section className="counter-section" ref={ref}>
      <div className="container">

        <div className="counter-heading">
          <h2>Our Achievements</h2>
          <p>
            We deliver reliable software, websites and digital solutions that
            help businesses grow.
          </p>
        </div>

        <div className="counter-grid">
          {counterData.map((item, index) => (
            <div className="counter-card" key={index}>

              <div className="counter-icon">
                {item.icon}
              </div>

              <h3>
                {inView && (
                  <CountUp
                    end={item.number}
                    duration={3}
                  />
                )}
                {item.suffix}
              </h3>

              <p>{item.title}</p>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Counter;